/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Pxk_Edit_TitleInputs */

const vi_scl_pxk_edit_title = /** @type {(inputs: Scl_Pxk_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa phiếu xuất lô lấy hương`)
};

/**

* @param {Scl_Pxk_Edit_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_pxk_edit_title = /** @type {((inputs?: Scl_Pxk_Edit_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Pxk_Edit_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_pxk_edit_title(inputs)
});